export default __webpack_public_path__ + "static/media/plusIcon.28bfee2d.svg";